<template>
  <div class="userSet">
    <el-dropdown
      class="a-user-set"
      @command="handleCommand"
      trigger="click">
      <span class="el-dropdown-link">
        <i class="el-icon-arrow-down el-icon--right"></i>
        <el-avatar :src="profile.avatar" :size="30">
          {{profileName}}
        </el-avatar>
      </span>
      <el-dropdown-menu slot="dropdown" size="medium">
        <el-dropdown-item disabled>{{profileName}}</el-dropdown-item>
        <el-dropdown-item divided></el-dropdown-item>
        <el-dropdown-item>
          <base-icon iconClass="theme" size="17px"></base-icon>
          {{$t('common.theme')}}
          <div>
            <span
              v-for="(item, index) in themeList"
              :key="index"
              :class="['theme_item', item.key === theme ? 'active' : '']"
              @click.stop="setTheme(item.key)"
              :style="{ 'background-color': item.color }"
            >
              <div class="theme_item_check"></div>
              <i class="theme_item_check_icon el-icon-check"></i>
            </span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item divided></el-dropdown-item>
        <template v-for="(item,index) in dropdownList">
          <el-dropdown-item :key="index" :divided="item.divided" :command="item.command">
            <base-icon :iconClass="item.icon" size="17px"></base-icon>
            {{item.name}}
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { themeList } from '@/assets/theme/setTheme';
import {
  mapGetters,
} from 'vuex';

export default {
  data() {
    return {
      dropdownList: [
        {
          name: this.$t('router.profile'),
          icon: 'userCenter',
          command: 'toProfile',
        },
        {
          name: this.$t('common.signOut'),
          // divided: true,
          icon: 'logOut',
          command: 'logOut',
        },
      ],
      themeList,
      theme: '',
    };
  },
  computed: {
    ...mapGetters(['profile', 'profileName']),
  },

  components: {},
  inject: ['reload'],
  mounted() {
    const { theme } = this.profile;
    this.theme = theme;
  },
  methods: {
    handleCommand(data) {
      if (data) this[data]();
    },
    changeTheme() {
      console.log('changeTheme', 'test');
    },
    toProfile() {
      this.$router.push({ name: 'profile' });
    },
    logOut() {
      // TODO 退出
      this.$store.dispatch('LogOut');
      this.$router.push('/sign');
    },
    setTheme(theme) {
      this.theme = theme;
      this.$store.dispatch('ChangeTheme', theme);
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../assets/theme/_themes.scss';
.userSet {
  min-width: 250px;
  @include background_image('background-img-nav');
  background-repeat: no-repeat;
  text-align: right;
  padding-right: 10px;
}
.a-user-set {
  cursor: pointer;
  .el-dropdown-link{
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 10px;
    flex-direction: row-reverse;
    color: #ffffff;
    .link-text {
      display: inline-block;
      padding-left: 5px;
    }
  }
  .el-avatar {
    background:#6c6e71;
  }
}
</style>
<style lang="scss">
.el-dropdown-menu {
  .theme_item{
    display: inline-block;
    position: relative;
    border: 1px solid rgba(255,255,255,0.2);
    margin-left: 5px;
    height: 17px;
    width: 17px;
    cursor: pointer;
    .theme_item_check_icon {
      display: none;
    }
    &.active {
      .theme_item_check_icon {
        position: absolute;
        right: -3px;
        top: 2px;
        display: block;
        color: #ffffff;
      }
    }
  }
}
</style>
